// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3sMy4","inner":"Footer_inner__j9Tny","nextIcon":"Footer_nextIcon__1-INm","innerLeft":"Footer_innerLeft__YF_Qc"};